// extracted by mini-css-extract-plugin
export default {"root":"Link_root__XrwRx"};